import { render, staticRenderFns } from "./ImageSetting.vue?vue&type=template&id=150750f4&scoped=true&"
import script from "./ImageSetting.vue?vue&type=script&lang=js&"
export * from "./ImageSetting.vue?vue&type=script&lang=js&"
import style0 from "./ImageSetting.vue?vue&type=style&index=0&id=150750f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150750f4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VIcon,VImg,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('150750f4')) {
      api.createRecord('150750f4', component.options)
    } else {
      api.reload('150750f4', component.options)
    }
    module.hot.accept("./ImageSetting.vue?vue&type=template&id=150750f4&scoped=true&", function () {
      api.rerender('150750f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Settings/ImageSetting.vue"
export default component.exports